<app-energy-graph [energy]="graphData" [co2]="co2"></app-energy-graph>